import { DialogRef } from '@angular/cdk/dialog';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';
import { EmsServicesService } from 'src/app/module/ems-master/services/ems-services.service';
import { InvoiceService } from 'src/app/module/invoices/invoice-service/invoice.service';
import * as JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { HttpClient } from '@angular/common/http';
import { ordersService } from 'src/app/module/orders/services/orders.service';
import { SharedService } from 'src/app/shared/shared.service';
import { STATUS } from 'src/app/constants/status.constant';
import { AssociateOrderAcceptComponent } from 'src/app/module/orders/components/associate-order-accept/associate-order-accept.component';
import { AddordersComponent } from 'src/app/module/orders/components/add-orders/add-orders.component';
import { MessageService } from 'primeng/api';
import { NeAddOrderComponent } from 'src/app/module/orders/components/ne-add-order/ne-add-order.component';

@Component({
  selector: 'app-view-edit-common',
  templateUrl: './view-edit-common.component.html',
  styleUrls: ['./view-edit-common.component.css'],
})
export class ViewEditCommonComponent {
  STATUS = STATUS;
  rowData: any;
  columns: any[];
  triggeredColumn: any;
  printData: boolean = false;
  componentName: any;
  viewHistory: any;
  pageNumber = 0;
  pageSize = 500;
  historyLists: any;
  filters: any;
  invoiceLineItem: any;
  currentUser: any;
  userDetails: any;
  invoiceLineItemPopUp: boolean = false;
  referenceNumber: any;
  paymentStatus: any;
  updatedInvoicePayload: any;
  rejectRemarksPopUpShow: any;
  rejectRemarks: any;
  selectedLineItemRow: any;
  roleName: any;
  groupedLineItems: any[] = [];
  counterPayload: any;
  userType: any;
  cancelLineItems: any;
  pendingLineItems: any;
  transactionData: any;
  sortingCol: string = 'id';
  direction: string = 'ASC';
  jobDetails: any;
  activeTabIndex = 0;
  jobLineItems: any;
  biddingHistory: any;
  jobAssociateMapping: any;
  transactionDataTransform: any;
  createCounterPopup: any = false;
  createCounterData: any;
  customerMumberOfVehicle: any;
  customerMaxSalary: any;
  BiddingHistoryPopup: boolean = false;
  vehicleProvideError: boolean = false;
  vendorPriceError: boolean = false;
  parentOrder: any;
  viewPickupPopup: boolean = false;
  viewPickupPopupData:any
  whatsAppNotification: any;
  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private ordersService: ordersService,
    private emsServices: InvoiceService,
    public sharedService: SharedService,
    public dialogService: DialogService,
    private messageService: MessageService
  ) {
    this.userDetails = JSON.parse(localStorage.getItem('UserDetails')!);
    this.userType = this.userDetails?.userType;
    this.rowData = this.config.data.rowData;
    this.columns = this.config.data.columns;
    this.triggeredColumn = this.config.data.triggeredColumn;
    this.componentName = this.config.data.componentName;
    this.viewHistory = this.config.data.viewHistory;
    this.invoiceLineItem = this.rowData?.invoiceLineItem || [];

    console.log('Row Data:', this.rowData);
    this.jobAssociateMapping = this.rowData?.jobLineItems;
    // .filter((item: any) => {
    //   return item.associateId == this.userDetails.id;
    // });
    console.log(this.jobAssociateMapping);
    this.rowData?.approvalUser?.filter((user: any) => {
      if (user?.approvalStatus == 1 && user?.viewStatus == 1) {
        this.currentUser = user;
        console.log(this.currentUser);
      }
    });
    // const userId = this.userDetails?.id;

    //     const shouldCallApi = this.rowData.invoiceLineItems.some((item:any) =>
    //       (item.approvalUser ?? []).some((user:any) =>
    //         user.userId === userId && user.approvalStatus > 1
    //       )
    //     );
    //     console.log(shouldCallApi)

    // const matchedInvoices = this.rowData?.invoiceLineItems.filter((item:any) =>
    //   item.approvalUser?.some((user:any) => user.userId === userId)
    // );

    // console.log("matchedInvoices",matchedInvoices)
  }
  columnPairs: any[][] = [];

  ngOnInit(): void {
    if (this.viewHistory && this.componentName === 'Budget') {
      this.filters = this.setFilter();
      // this.getList();
    }

    if (this.userType === 'CUSTOMER') {
      this.getJobsDetails(this.rowData?.jobCode);
    }
    if (this.userType === 'VENDOR' || this.userType === 'CUSTOMER') {
      this.getPerentOrder(this.rowData?.jobCode);
    }
    setTimeout(() => {
      this.groupJobLineItemsByVendor();
      // this.transactionPraposal();
    }, 500);
    // this.userDetails?.userRole.filter((role: any) => {
    //   if (role?.roleName == 'ROLE_FINANCE_CORPORATE' || role?.roleName == 'ROLE_FINANCE_MANPOWER' ||
    //     role?.roleName == 'ROLE_FINANCE_PETTYCASH' || role?.roleName == 'ROLE_FINANCE_PAYMENT_CHECKER'
    //   ) {
    //     this.roleName = role.roleName
    //     console.log("roleName", this.roleName)
    //   }
    // });

    this.setColumnPairs();
  }
  setColumnPairs() {
    this.columnPairs = [];
    for (let i = 0; i < this.columns.length; i += 2) {
      this.columnPairs.push([this.columns[i], this.columns[i + 1]]);
    }
  }

  closeDialog() {
    this.ref.close(this.roleName);
  }

  getColumnPairs(columns: any[]): any[][] {
    const pairs = [];
    for (let i = 0; i < columns.length; i += 2) {
      pairs.push([columns[i], columns[i + 1]]);
    }
    return pairs;
  }

  isArrayOfObjects(value: any): boolean {
    return (
      Array.isArray(value) && value.length > 0 && typeof value[0] === 'object'
    );
  }

  getFormattedValue(key: any): any {
    if (!this.rowData || !this.rowData[key]) return '';

    const value = this.rowData[key];
    if (key === 'status') {
      return value == 1 ? 'Active' : 'Inactive';
    }

    if (key === 'invoiceUrl') {
      return '';
    }

    if (this.isArrayOfObjects(value)) {
      if (key === 'expenseAssociated') {
        return value.map((obj: any) => obj.expense).join(', ');
      } else if (key === 'userRole') {
        return value.map((obj: any) => obj.roleDescription).join(', ');
      } else if (key === 'warehouseList') {
        return value
          .map((obj: any) => obj.clientName + ' - ' + obj.warehouseName)
          .join(', ');
      } else if (
        value.map(
          (el: any) => el.invoiceLineItemExpense?.attributeName === 'Invoice No'
        ) &&
        this.columns.some((el: any) => el.header !== 'Expenses')
      ) {
        return this.getInvoiceNumbers(value);
      } else if (key === 'invoiceLineItems') {
        return value.map((obj: any) => obj.expense);
      }

      // else if (key === 'invoiceLineItems') {
      //   return this.getInvoiceNumbers(value);
      // }
      return value.map((obj: any) => this.getDisplayValue(obj)).join(', ');
    }

    return value;
  }

  getInvoiceNumbers(lineItems: any[]): string {
    if (!lineItems) return '';

    const invoiceNumbers: string[] = [];
    lineItems.forEach((lineItem) => {
      const invoiceAttr = lineItem.invoiceLineItemExpense?.find(
        (attr: any) => attr.attributeName === 'Invoice No'
      );
      if (invoiceAttr?.attributeValue) {
        invoiceNumbers.push(invoiceAttr.attributeValue);
      }
    });
    return invoiceNumbers.join(', ');
  }

  getDisplayValue(obj: any): string {
    return obj?.name || obj?.label || JSON.stringify(obj);
  }

  setFilter() {
    const obj = [];
    if (this.componentName === 'Budget') {
      obj.push({
        key: 'BUDGET_IN',
        value: this.rowData.id,
      });
    }
    return obj;
  }

  getList() {
    this.historyLists = [];
    this.ordersService
      .getBudgetTransactions(this.filters, this.pageNumber, this.pageSize)
      .subscribe(
        (data: any) => {
          if (data) {
            this.historyLists = data?.responseObject?.content;
            this.historyLists = this.historyLists.map((el: any) => ({
              status: 'Rs. ' + el?.approvedBudget,
              date: el.createdAt,
              icon: 'pi pi-wallet',
              color: '#607D8B',
              remarks: el.remarks,
            }));
          }
        },
        (err) => {
          // console.log(err);
          this.historyLists = [];
        }
      );
  }

  approveLineItem(row: any, action: any) {
    console.log(row);
    // 1. Get current user
    const user = row.approvalUser.find(
      (ap: any) => ap.userId === this.userDetails?.id
    );

    if (user) {
      // 2. Update approvalStatus
      if (action == 'approve') {
        user.approvalStatus = 2;
      }
      if (action == 'reject') {
        this.invoiceLineItemPopUp = true;
        user.approvalStatus = 3;
      }
      // 3. Remove current user from the list
      const others = row.approvalUser.filter(
        (ap: any) => ap.userId !== this.userDetails?.id
      );
      // 4. Recreate the final user array with updated one
      const finalUserList = [...others, user];

      // 5. Create payload with final user list
      const payload1 = {
        id: row.id,
        approvalUser: finalUserList,
      };

      const payload = {
        id: row.id,
        currentApprovalUserLineId: this.currentUser?.id,
        currentApprovalUserId: this.currentUser?.userId,
        approvalUser: finalUserList,
      };
      console.log(payload);
      this.emsServices.approveInvoiceLineItem(payload).subscribe((res: any) => {
        if (res) {
          console.log(res);
          this.getInvoiceList();
          // this.ref.close(res);
        }
      });

      // const user2 = this.rowData?.approvalUser.find((user: any) => {
      //   return user?.approvalStatus === 1 && user?.viewStatus === 1;
      // });
      // const dataToSend = {
      //   id: user2.id ? user2.id : this.rowData?.id,
      //   approvalStatus: 1,
      //   budgetId: row?.budgetId,
      // }
      // if(action == 'approve'){
      //   dataToSend.approvalStatus = 2
      // }else if(action == 'reject'){
      //   dataToSend.approvalStatus = 3
      // }else if(action == 'comment'){
      //   dataToSend.approvalStatus = 4
      // }
      // console.log(dataToSend)

      // const shouldCallApi = this.rowData.invoiceLineItems.some((item:any) =>
      //   (item.approvalUser ?? []).some((user:any) =>
      //     user.userId === this.userDetails?.id && user.approvalStatus > 1
      //   )
      // );
      // console.log(shouldCallApi)

      //   const userId = this.userDetails?.id;
      //   const matchingApprovalUsers = this.rowData.invoiceLineItems.flatMap((item:any) =>
      //     (item.approvalUser ?? []).filter((user:any) =>
      //       user.userId === userId
      //     )
      //   );
      // console.log("matchingApprovalUsers",matchingApprovalUsers)
      // const allGreaterThanOne = matchingApprovalUsers.every((entry:any) => entry.approvalStatus > 1);
      // const allApprovalStatusSame = matchingApprovalUsers.every((item:any) => item.approvalStatus === matchingApprovalUsers[0].approvalStatus);
      // let differentVar: string | null = null;
      // if (!allApprovalStatusSame) {
      //   differentVar = 'Approval statuses are not the same';
      //   dataToSend.approvalStatus = 9
      // }

      // console.log('allGreaterThanOne',allGreaterThanOne)
      // if(allGreaterThanOne){
      //   this.emsServices.approveInvoice(dataToSend).subscribe((res: any) => {
      //     if(res){
      //       console.log(res)
      //     this.ref.close(res);

      //     }
      //   })
      // }
    } else {
      console.warn('User not found in approvalUser list');
    }
  }
  rejectLineItem(row: any, action: any) {
    console.log('reject');
    this.rejectRemarksPopUpShow = true;
    console.log(row);
    this.selectedLineItemRow = row;
  }
  rejectLineItemClick() {
    const user = this.selectedLineItemRow.approvalUser.find(
      (ap: any) => ap.userId === this.userDetails?.id
    );
    if (user) {
      user.approvalStatus = 3;
    }
    const others = this.selectedLineItemRow.approvalUser.filter(
      (ap: any) => ap.userId !== this.userDetails?.id
    );
    const finalUserList = [...others, user];
    console.log('rejectLineItem');
    const payload = {
      id: this.selectedLineItemRow.id,
      currentApprovalUserLineId: this.currentUser?.id,
      currentApprovalUserId: this.currentUser?.userId,
      approvalUser: finalUserList,
      remarks: this.rejectRemarks,
    };
    console.log('Reject Payload', payload);
    this.emsServices.approveInvoiceLineItem(payload).subscribe((res: any) => {
      if (res) {
        console.log(res);
        this.getInvoiceList();
        this.rejectRemarksPopUpShow = false;
        this.rejectRemarks = '';
        // this.ref.close(res);
      }
    });
  }

  getInvoiceList() {
    // console.log("userDetails",this.userDetails?.id)
    const payload = [
      {
        key: 'INVOICE_IN',
        value: this.rowData?.id,
      },
    ];

    this.emsServices
      .getInvoiceInfo(payload, this.pageNumber, this.pageSize, 'id', 'ASC')
      .subscribe((data: any) => {
        if (data) {
          // console.log(data?.responseObject?.content[0])
          this.rowData = data?.responseObject?.content[0];
        }
      });
  }

  updateInvoice(lineitem: any, item: any) {
    this.invoiceLineItemPopUp = true;
    this.updatedInvoicePayload = {
      id: lineitem.id,
      paymentStatus: this.paymentStatus,
      referenceNumber: this.referenceNumber,
    };
  }
  updateInvoiceClick() {
    this.updatedInvoicePayload['paymentStatus'] = this.paymentStatus;
    this.updatedInvoicePayload['referenceNumber'] = this.referenceNumber;
    Object.keys(this.updatedInvoicePayload).forEach((key) => {
      const value = this.updatedInvoicePayload[key];
      if (value === null || value === undefined || value === '') {
        delete this.updatedInvoicePayload[key];
      }
    });
    this.emsServices
      .updateInvoiceLineItem(this.updatedInvoicePayload)
      .subscribe((data: any) => {
        if (data) {
          // console.log(data?.responseObject?.content[0])
          this.getInvoiceList();
          this.invoiceLineItemPopUp = false;
          this.referenceNumber = '';
          this.paymentStatus = '';
        }
      });
  }

  getStatusText(value: string, userType: 'CUSTOMER' | 'VENDOR' | 'USER'): string {
      if (value === 'PendingOnVendor') {
      return userType === 'VENDOR' ? 'Pending' : 'Pending On Vendor';
      }
      if (value === 'AcceptedByVendor') {
      return userType === 'VENDOR' ? 'Accepted' : 'Accepted By Vendor';
      }
      if (value === 'RejectedByVendor') {
      return userType === 'VENDOR' ? 'Rejected' : 'Rejected By Vendor';
      }

      if (value === 'PendingOnCustomer') {
        return userType === 'CUSTOMER' ? 'Pending' : 'Pending On Apollo';
      }
      if (value === 'RejectedByCustomer') {
        return userType === 'CUSTOMER' ? 'Rejected' : 'Rejected By Apollo';
      }
      if (value === 'AcceptedByCustomer') {
        return userType === 'CUSTOMER' ? 'Accepted' : 'Accepted By Apollo';
      }
      if (value === 'Expire') {
        return userType === 'CUSTOMER' ? 'Expired' : 'Expired';
      }
      return value;

    
    // switch (value) {
    //   case 'PendingOnVendor':
    //     return 'Pending';
    //   case 'AcceptedByVendor':
    //     return 'Accepted';
    //   case 'RejectedByVendor':
    //     return 'Rejected';
    //   case 'PendingOnCustomer':
    //     return 'Pending';
    //   case 'AcceptedByCustomer':
    //     return 'Accepted';
    //   case 'RejectedByCustomer':
    //     return 'Rejected';
    //   case 'AcceptedByUser':
    //     return 'Accepted';
    //   case 'RejectedByUser':
    //     return 'Rejected';
    //   default:
    //     return value;
    // }
  }

  isFinanceRole(role: string): boolean {
    return [
      'ROLE_FINANCE_CORPORATE',
      'ROLE_FINANCE_MANPOWER',
      'ROLE_FINANCE_PETTYCASH',
    ].includes(role);
  }
  isApproved(status: string): boolean {
    return status === 'APPROVED' || status === 'PARTIALLY_APPROVED';
  }
  isPaymentCheckRole(role: string): boolean {
    return ['ROLE_FINANCE_PAYMENT_CHECKER'].includes(role);
  }

  async downloadInvoices(data: any) {
    const zip = new JSZip();

    for (const item of data) {
      if (item.lineItemApprovalStatus === 'REJECTED') {
        console.log(`Skipping rejected item: ${item.expense}`);
        continue;
      }
      try {
        const response = await fetch(item.invoiceUrl);
        const blob = await response.blob();
        const fileName = item.invoiceUrl.split('/').pop() || 'invoice.pdf';
        const folder = zip.folder(item.expense);
        folder?.file(fileName, blob);
      } catch (err) {
        console.error('Failed to download:', err);
      }
    }

    zip.generateAsync({ type: 'blob' }).then((content) => {
      saveAs(content, 'invoices.zip');
    });
  }

  searchTerm: string = '';

  labors = [
    {
      name: 'Akash',
      age: 44,
      experience: 12,
      availability: 'Yes',
      selected: false,
    },
    {
      name: 'Raj',
      age: 33,
      experience: 6,
      availability: 'Yes',
      selected: false,
    },
    {
      name: 'Raju',
      age: 23,
      experience: 2,
      availability: 'No',
      selected: false,
    },
    {
      name: 'Rj',
      age: 23,
      experience: 1,
      availability: 'Yes',
      selected: false,
    },
  ];

  filteredLabors = [...this.labors];

  get allAvailableSelected(): boolean {
    return this.filteredLabors
      .filter((l) => l.availability === 'Yes')
      .every((l) => l.selected);
  }

  filterLabors() {
    const term = this.searchTerm.toLowerCase();
    this.filteredLabors = this.labors.filter((labor) =>
      labor.name.toLowerCase().includes(term)
    );
  }

  toggleSelectAll(event: any) {
    const checked = event.target.checked;
    this.filteredLabors.forEach((labor) => {
      if (labor.availability === 'Yes') {
        labor.selected = checked;
      }
    });
    this.onSelectionChange(null);
  }
  // ORDER PAGE
  onSelectionChange(_: any) {
    const selected = this.labors.filter((l) => l.selected);
    console.log('Selected Labors:', selected);
  }

  getJobsDetails(orderNo: any) {
    this.sortingCol = 'jobLineItems.vendorPrice'
    const payload = [
      {
        key: 'ORDER_TYPE',
        value: 'Child', 
      },
      {
        key: 'ORDER_NUMBER_IN',
        value: orderNo,
      },
    ];
    // this.direction = 'ASC';
    this.ordersService
      .getOrders(
        payload,
        this.pageNumber,
        this.pageSize,
        this.sortingCol,
        this.direction
      )
      .subscribe({
        next: (res: any) => {
          this.jobDetails = res?.responseObject?.content || [];
          this.groupedLineItems = [];

          this.jobDetails.forEach((job: any) => {
            const group = {
              vendorName: job.vendorName,
              rank: job.jobLineItems[0].rank ?? '',
              vendorId: job.vendorId,
              id: job.id,
              childJobCode: job.childJobCode,
              version: job?.version,
              counterNumber: job.counterNumber,
              finalAcceptance: job.finalAcceptance,
              items: job.jobLineItems,
              status: job.status,
              updatedByName: job.updatedByName,
              showCounter: false,
              counterInputs: job.jobLineItems.map((item: any) => ({
                headCount: item.headCount,
                maxSalary: item.maxSalary,
              })),
            };

            this.groupedLineItems.push(group);
            this.biddingHistory = group.items.map((el: any) => el.id);
          });
          this.getWhatsAppLog(this.jobDetails)

        },
      });
  }

  getWhatsAppLog(jobDetails:any){
    // console.log('jobDetails',jobDetails)
    // console.log(this.groupedLineItems)
    const jobCode = jobDetails.map((item: { childJobCode?: string }) => item.childJobCode)
      .filter(Boolean)
      .join(',');

    // console.log(jobCode);
    const payload = [
        {
            "key": "REFRENCE_CODE_IN",
            "value": jobCode
        },
        {
            "key": "NOTIFICATION_TYPE",
            "value": "WHATSAPP"
        }
    ]

    // console.log(payload);
    this.ordersService.getNotificationLogs(payload).subscribe((res: any) => {
          if(res?.body?.responseStatus){
          // console.log('ressssss', res.body.responseObject?.content)
          // const notifications  = res?.body?.responseObject?.content || [];
           this.whatsAppNotification = res.body.responseObject?.content
          function normalize(value: any): string {
  return String(value || '')
    .trim()
    .toUpperCase();
}
const notifications = res.body.responseObject?.content || [];

const notificationMap = new Map<
  string,
  { notificationStatus: string; recipient: string }
>();

notifications.forEach((n: any) => {
  const key = normalize(n.referenceId);

  if (key) {
    notificationMap.set(key, {
      notificationStatus: n.notificationStatus,
      recipient: n.recipient
    });
  }
});

this.groupedLineItems = this.groupedLineItems.map((item: any) => {
  const key = normalize(item.childJobCode);

  const notificationData = notificationMap.get(key);

  return notificationData
    ? {
        ...item,
        notificationStatus: notificationData.notificationStatus,
        notificationRecipient: notificationData.recipient
      }
    : item;
});


          // console.log('updatedGroupedLineItems', this.groupedLineItems);
      }
    })
    // getNotificationLogs

  }

  getPerentOrder(orderNo: any) {
    const payload = [
      {
        key: 'ORDER_TYPE',
        value: 'Parent',
      },
      {
        key: 'ORDER_NUMBER_IN',
        value: orderNo,
      },
    ];
    // this.direction = 'ASC';
    this.ordersService
      .getOrders(
        payload,
        this.pageNumber,
        this.pageSize,
        this.sortingCol,
        this.direction
      )
      .subscribe({
        next: (res: any) => {
          this.parentOrder = res?.responseObject?.content[0] || [];
          // console.log("this.parentOrder",this.parentOrder)
        }
      })   
  }

whatsApplogData(childJobCode: any) {
  if (!childJobCode || !Array.isArray(this.whatsAppNotification)) {
    return [];
  }

  const normalizedChild = String(childJobCode).trim().toUpperCase();

  return this.whatsAppNotification.filter((n: any) =>
    String(n.referenceId).trim().toUpperCase() === normalizedChild
  );
}

  

  sortData(columnKey:any){
    this.sortingCol = columnKey,
    this.direction = this.direction == 'ASC' ? 'DESC' : 'ASC'
    this.getPerentOrder(this.rowData?.jobCode)
    this.getJobsDetails(this.rowData?.jobCode)
  }

  onVendorTabClick(index: number): void {
    this.activeTabIndex = index;

    const selectedVendor = this.jobDetails[index];
    const selectedOrderCode =
      selectedVendor?.orderCode || selectedVendor?.jobCode;

    if (selectedOrderCode) {
      // this.groupedLineItems = [];
      this.getJobsDetails(selectedOrderCode);
      setTimeout(() => {
        // this.transactionPraposal();
      }, 500);
    }
  }

  groupJobLineItemsByVendor(): void {
    const job = this.rowData;
    let vendorIds: string[] = [];

    const groupedCancel: { [vendorId: string]: any } = {};
    const groupedPending: { [vendorId: string]: any } = {};

    if (this.userDetails?.vendorMapping?.length > 0) {
      vendorIds = this.userDetails.vendorMapping.map(
        (el: any) => el.vendorId || el.id
      );
    }

    // Process jobLineItems from the job object
    this.jobLineItems = job.jobLineItems || [];
    if (this.userType === 'VENDOR') {
      this.biddingHistory = this.jobLineItems.map((el: any) => el.id);
    }

    for (let item of this.jobLineItems) {
      const vendorId = job.vendorId; // Use vendorId from job, as items don't have vendorId
      if (
        this.userDetails?.userType === 'VENDOR' &&
        !vendorIds.includes(vendorId)
      ) {
        continue;
      }

      const targetGroup =
        job.status === 'Cancel' ? groupedCancel : groupedPending;

      if (!targetGroup[vendorId]) {
        targetGroup[vendorId] = {
          vendorName: job.vendorName,
          status: job.status,
          rank: job.jobLineItems[0].rank ?? '',
          items: [],
        };
      }

      targetGroup[vendorId].items.push(item);
    }

    // Function to transform group object to sorted array
    const transformGroups = (groupMap: any) => {
      return Object.values(groupMap).map((group: any) => {
        const items = group.items;
        const counterIndexSet = new Set<number>();

        items.forEach((item: any) => {
          if (
            typeof item.counterIndex === 'number' &&
            job.status === 'PendingOnVendor'
          ) {
            counterIndexSet.add(item.counterIndex);
          }
        });

        return group;
      });
    };

    // this.cancelLineItems = transformGroups(groupedCancel);
    this.pendingLineItems = transformGroups(groupedPending);

    // this.cancelLineItems.sort((a: any, b: any) => a.vendorName.localeCompare(b.vendorName));
    this.pendingLineItems.sort((a: any, b: any) =>
      a.vendorName.localeCompare(b.vendorName)
    );

    console.log(this.pendingLineItems,'------------------pendingLineItems')
  }

  transactionPraposal(data: any) {
    console.log('biddingHistory', this.biddingHistory);
    if (this.biddingHistory) {
      const payload = [
        {
          key: 'ID_IN',
          value: data?.items[0]?.id,
          // value: this.biddingHistory?.toString()
        },
        {
          key: 'USER_TYPE',
          value: this.userDetails?.userType,
          // value: this.biddingHistory?.toString()
        },
      ];
      console.log('ddd', data);
      this.BiddingHistoryPopup = true;
      this.pageSize = 20;
      this.ordersService
        .getLineItemTransactions(payload, this.pageNumber, this.pageSize)
        .subscribe((res: any) => {
          console.log(res,"resresresres")
          this.transactionData = res?.responseObject?.content;

          this.transactionDataTransform = Object.values(
            this.transactionData.reduce((acc: any, row: any) => {
              if (!acc[row.counter]) {
                acc[row.counter] = { counter: row.counter, rows: [] };
              }
              acc[row.counter].rows.push(row);
              return acc;
            }, {})
          );
          console.log(
            'this.transactionData : ' + this.transactionDataTransform
          );
        },err => {
        // console.log(err);
        this.transactionData = []
      });;
    }
  }
  // groupJobLineItemsByVendor(): void {
  //     const jobLineItems = this.rowData?.jobLineItems || [];
  //     let vendorIds: string[] = [];

  //     const groupedCancel: { [vendorId: string]: any } = {};
  //     const groupedPending: { [vendorId: string]: any } = {};

  //     if (this.userDetails?.vendorMapping?.length > 0) {
  //       vendorIds = this.userDetails.vendorMapping.map((el: any) => el.vendorId || el.id);
  //     }

  //     for (let item of jobLineItems) {
  //       const vendorId = item.vendorId;
  //       if (this.userDetails?.userType === 'VENDOR' && !vendorIds.includes(vendorId)) {
  //         continue;
  //       }

  //       const targetGroup = item.status === 'Cancel' ? groupedCancel : groupedPending;

  //       if (!targetGroup[vendorId]) {
  //         targetGroup[vendorId] = {
  //           vendorName: item.vendorName,
  //           vendorId: vendorId,
  //           items: [],
  //           showCounter: false,
  //           counterInputs: [],
  //           previousCounters: [],
  //           previousCountersIndexes: [],
  //         };
  //       }

  //       targetGroup[vendorId].items.push(item);
  //     }

  //     // Function to transform group object to sorted array
  //     const transformGroups = (groupMap: any) => {
  //       return Object.values(groupMap).map((group: any) => {
  //         const items = group.items;
  //         group.counterInputs = items.map(() => ({}));
  //         return group;
  //       });
  //     };

  //     this.cancelLineItems = transformGroups(groupedCancel);
  //     this.pendingLineItems = transformGroups(groupedPending);

  //     this.cancelLineItems.sort((a: any, b: any) => a.vendorName.localeCompare(b.vendorName));
  //     this.pendingLineItems.sort((a: any, b: any) => a.vendorName.localeCompare(b.vendorName));
  // }

  orderUpdate(data: any, type: 'ACCEPT' | 'REJECT') {
    const status =
      this.userType === 'VENDOR'
        ? type === 'ACCEPT'
          ? STATUS.AcceptedByVendor
          : STATUS.RejectedByVendor
        : type === 'ACCEPT'
        ? STATUS.AcceptedByCustomer
        : STATUS.RejectedByCustomer;

    let updatePayload;

    if (this.userType === 'CUSTOMER') {
      const activeVendor = this.jobDetails[this.activeTabIndex];
      updatePayload = {
        id: data?.id,
        status,
        version: data?.version
      };
    } else {
      updatePayload = {
        id: this.rowData?.id,
        status,
        version: this.rowData?.version,
        maxSalary: this.parentOrder?.jobLineItems[0]?.maxSalary
      };
    }

    console.log(`${type}:`, updatePayload);

    this.ordersService.updateLineItems(updatePayload).subscribe({
      next: (res: any) => {
        this.ref.close();
        console.log(`${type} success:`, res);
      },
      error: (err) => console.error(`${type} failed:`, err),
    });
  }

  hasVendorData(group: any): boolean {
    // console.log(group)
    return group?.items?.some(
      (item: any) => item?.vendorPrice1 != null && item?.vendorCount1 != null
    );
  }

  hasVendorStatus(): boolean {
    if (this.userType === 'VENDOR') {
      const statuses = this.rowData?.status;
      return (
        !statuses.includes(STATUS.AcceptedByVendor) &&
        !statuses.includes(STATUS.RejectedByVendor) &&
        !statuses.includes(STATUS.AcceptedByCustomer) &&
        !statuses.includes(STATUS.RejectedByCustomer)
      );
    }

    // else {
    //   const statuses = this.jobDetails?.status;
    //   return !statuses.includes(STATUS.AcceptedByCustomer) && !statuses.includes(STATUS.RejectedByCustomer);
    // }

    return true;
  }

  hasCustomerStatus(data: any): boolean {
    const activeVendor = this.jobDetails[this.activeTabIndex];

    const statuses = data?.status;
    return (
      !statuses.includes(STATUS.AcceptedByCustomer) &&
      !statuses.includes(STATUS.RejectedByCustomer) &&
      !statuses.includes(STATUS.PendingOnVendor) &&
      !statuses.includes(STATUS.AcceptedByVendor) &&
      !statuses.includes(STATUS.RejectedByVendor)
    );
  }

  customerAccRejectBtn(group: any): boolean {
    // console.log(group)
    const activeVendor = this.jobDetails[this.activeTabIndex];

    const statuses = group?.status;
    return (
      !statuses.includes(STATUS.AcceptedByCustomer) &&
      !statuses.includes(STATUS.RejectedByCustomer) &&
      !statuses.includes(STATUS.PendingOnVendor) &&
      !statuses.includes(STATUS.RejectedByVendor)
    );
  }

  toggleCounterMode(group: any): void {
    group.showCounter = !group.showCounter;

    if (group.showCounter) {
      group.counterInputs = group.items.map((item: any) => ({
        headCount: item.headCount,
        maxSalary: item.maxSalary,
        skillId: item.skillId,
      }));
    }
  }

  showCounterpopUp(group: any) {
    this.createCounterPopup = true;
    this.createCounterData = group;
    console.log(this.createCounterData);
  }
onCounterPopupClose(){
  this.customerMumberOfVehicle= '',
        this.customerMaxSalary= ''
}
  submitCounter(group: any) {
    const items = group.items || [];
    const counterLineItem = items?.[0]?.counterIndex ?? 0;

    let cancelItems: any[] = [];
    let newItems: any[] = [];

    if (this.userDetails?.userType === 'VENDOR') {
      // group.counterIndex = (group.counterIndex || 0);
      // VENDOR is creating counter (Pending_C)
      newItems = group.counterInputs?.map((input: any, index: number) => ({
        vehicleProvide: input.vehicleProvide,
        vendorPrice: input.vendorPrice,
        id: items[index]?.id,
        version: this.rowData?.version
      }));

      this.counterPayload = {
        id: this.rowData?.id,
        "finalAcceptance":'VENDOR',
        status: STATUS.PendingOnCustomer,
        jobLineItems: [...cancelItems, ...newItems],
        version: this.rowData?.version
      };

      // cancelItems = items
      //   .filter((item: any) => item.status === 'Pending_V' && item.counterIndex)
      //   .map((item: any) => ({
      //     id: item.id,
      //     vendorId: group.vendorId,
      //     status: 'Cancel'
      //   }));
    } else {
      const activeVendor = this.jobDetails[this.activeTabIndex];

      newItems = group?.counterInputs?.map((input: any, index: number) => {
        const matchedItem = group?.items?.find(
          (item: any) => item.skillId === input.skillId
        );

        return {
          version: this.rowData?.version,
          id: matchedItem?.id,
          skillId: input.skillId,
          headCount: input.headCount,
          maxSalary: input.maxSalary,
          // vendorPrice: 0,
          // vendorCount: 0,
        };
      });

      // cancelItems = group?.items?.map((item: any) => ({
      //   id: item.id,
      //   status: 'Cancel'
      // }));

      this.counterPayload = {
        counterNumber: activeVendor?.counterNumber + 1,
        id: activeVendor?.id,
        status: STATUS.PendingOnVendor,
        jobLineItems: [...newItems],
        version: this.rowData?.version
      };
    }

    console.log('Submitting counter:', this.counterPayload);

    this.ordersService.updateLineItems(this.counterPayload).subscribe({
      next: (res: any) => {
        console.log(res);
        this.ref.close();
      },
      error: (err) => console.log('Update lineItem failed: ' + err),
    });
  }

  getUniqueSkills(): string {
    const skillSet = new Set<string>();

    this.rowData?.jobLineItems?.forEach((item: any) => {
      if (item.skill) {
        skillSet.add(item.skill);
      }
    });

    return Array.from(skillSet).join(', ');
  }

  pushToAssociate() {
    const fullData = {
      parentData : this.parentOrder,
      childData: this.groupedLineItems
    }
    this.ref = this.dialogService.open(AssociateOrderAcceptComponent, {
      header: `Order No. ${this.rowData?.jobCode}`,
      data: fullData,
      width: '50vw',
      contentStyle: { overflow: 'auto', position: 'top' },
      draggable: true,
      styleClass: 'no-close-icon-dialog',
    });
    this.ref.onClose.subscribe((data: any) => {
      if (data) {
        this.getPerentOrder(this.rowData?.jobCode)
        this.getJobsDetails(this.rowData?.jobCode)
        // console.log('resss', data);
        // this.ref.close(data);
        // this.messageService.add({
        //   severity: 'success',
        //   summary: 'Success',
        //   detail: data?.responseMessage,
        // });
        // this.getList()
      }
    });
  }

  orderUpdateAssociate(data: any, type: 'ACCEPT' | 'REJECT') {
    console.log(type);
    const associatedata = data.find((item: any) => {
      return item.associateId == this.userDetails.id;
    });
    console.log(data, associatedata);
    let updatePayload;
    updatePayload = {
      version: this.rowData?.version,
      id: this.rowData?.id,
      jobAssociateMapping: [
        {
          id: associatedata?.id,
          associateId: associatedata?.associateId,
          associateAcceptance: type == 'ACCEPT' ? true : false,
          // "status": type == 'ACCEPT' ? 'AcceptedByUser' : 'RejectedByUser'
        },
      ],
    };

    console.log(`${type}:`, updatePayload);

    this.ordersService.updateLineItems(updatePayload).subscribe({
      next: (res: any) => {
        this.ref.close();
        console.log(`${type} success:`, res);
      },
      error: (err) => console.error(`${type} failed:`, err),
    });
  }

  editEvent() {
    this.addBudget('Edit');
  }

  addBudget(type: any) {
    this.ref = this.dialogService.open(NeAddOrderComponent, {
      header: `${type} Order`,
      data:
        type == 'Add'
          ? {}
          : {
              editData: [this.rowData],
              edit: true,
            },
      width: '70vw',
      contentStyle: { overflow: 'auto', position: 'top' },
      draggable: true,
      styleClass: 'no-close-icon-dialog',
    });
    this.ref.onClose.subscribe((data: any) => {
      console.log('resss', data);
      // if (data) {
      //   this.messageService.add({
      //     severity: 'success',
      //     summary: 'Success',
      //     detail: data?.responseMessage,
      //   });
      // }
      // this.getList()
    });
  }

  pushToVendor() {
    const payload = {
      id: this.rowData?.id,
      status: STATUS.PendingOnVendor,
      vendorIds: [1],
    };

    this.ordersService.addOrUpdate(payload).subscribe((data: any) => {
      if (data) {
        // this.messageService.add({
        //   severity: 'success',
        //   summary: 'Success',
        //   detail: 'Order has been successfully pushed to the vendor'
        // })
        this.ref.close(data);
      }
    });
  }

  cancelOrder() {
    const payload = {
      id: this.rowData?.id,
      status: STATUS.Cancel,
      // vendorIds: [
      //   1
      // ]
    };
    this.ordersService.addOrUpdate(payload).subscribe((data: any) => {
      if (data) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Your order has been canceled successfully.',
        });
        this.ref.close(data);
      }
    });
  }

  get showCancelBtn(): boolean {
    // Convert string -> Date (dd-MM-yyyy HH:mm:ss +0530)
    const [datePart, timePart, offset] = this.rowData?.fromDate.split(' ');
    const [day, month, year] = datePart.split('-');
    const isoString = `${year}-${month}-${day}T${timePart}${offset}`;
    const fromDateObj = new Date(isoString);

    const now = new Date();

    return now < fromDateObj; // show button if current time < fromDate
  }

  submitCounterCustomer(data: any) {
    console.log(data);
    let newItems: any[] = [
      {
        numberOfVehicle: this.customerMumberOfVehicle,
        maxSalary: this.customerMaxSalary,
        id: data?.items[0].id
      },
    ];

    console.log(this.customerMumberOfVehicle);
    console.log(this.customerMaxSalary);

    this.counterPayload = {
      "finalAcceptance":'CUSTOMER',
      counterNumber: data?.counterNumber + 1,
      id: data?.id,
      status: STATUS.PendingOnVendor,
      jobLineItems: [...newItems],
      version: data?.version
    };
    console.log(this.counterPayload);

    this.ordersService.updateLineItems(this.counterPayload).subscribe({
      next: (res: any) => {
        console.log(res);
        this.ref.close();
        this.createCounterPopup = false;
        this.customerMumberOfVehicle= '',
        this.customerMaxSalary= ''
      },
      error: (err) => console.log('Update lineItem failed: ' + err),
    });
  }

 validateVehicleProvide(index: number, item: any) {
  console.log(this.pendingLineItems[index])
  // console.log(this.pendingLineItems[index]?.items[index]?.numberOfVehicle)
  const numberOfVehicle = this.pendingLineItems[index]?.items[index]?.numberOfVehicle
  const vehicleProvide = this.pendingLineItems[index].counterInputs[index].vehicleProvide
  console.log('vehicleProvide',vehicleProvide , 'numberOfVehicle' , numberOfVehicle)

  if(vehicleProvide > numberOfVehicle){
    this.vehicleProvideError = true
  }else{
    this.vehicleProvideError = false
  }
  // const val = this.pendingLineItems[index]?.items[index]?.numberOfVehicle;
  // if (val > item.numberOfVehicle) {
  //   this.pendingLineItems[index].counterInputs[index].vehicleProvideError = true;
  //   this.vehicleProvideError = true
  // } else {
  //   this.pendingLineItems[index].counterInputs[index].vehicleProvideError = false;
  //   this.vehicleProvideError = false

  // }
}

validateVendorPrice(index: number, item: any) {
  const vendorPrice = this.pendingLineItems[index]?.items[index]?.vendorPrice
  const vendorProvideprice = this.pendingLineItems[index].counterInputs[index].vendorPrice
    // console.log('vehicleProvide',vendorProvideprice , 'vendorPrice' , vendorPrice)

   
  // const val = this.pendingLineItems[index].counterInputs[index].vendorPrice;
  // if (val > item.maxSalary) {
  //   this.pendingLineItems[index].counterInputs[index].vendorPriceError = true;
  // } else {
  //   this.pendingLineItems[index].counterInputs[index].vendorPriceError = false;
  // }
  if(this.rowData?.counterNumber > 0){
  if(vendorProvideprice > vendorPrice){
        this.vendorPriceError = true
      }else{
        this.vendorPriceError = false
      }
  }


}


viewPickUpDropLocation(data:any){
  this.viewPickupPopup = true
  this.viewPickupPopupData = data
}
viewPickupPopupClose(){
  this.viewPickupPopup = false

}
}
